import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const heroDefaultBlocks: BlockNode[] = [
  {
    id: 'hero-heading',
    type: 'text',
    content: { type: 'text', value: 'Welcome to our store', fontSize: 48, fontWeight: 700, textAlign: 'center' },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'hero-subheading',
    type: 'text',
    content: { type: 'text', value: 'Discover our latest collection', fontSize: 18, fontWeight: 400, textAlign: 'center' },
    layout: { order: 1, widthPct: 100 },
  },
  {
    id: 'hero-cta',
    type: 'button',
    content: { type: 'button', label: 'Shop Now', href: '/collections', variant: 'filled', size: 'lg' },
    layout: { order: 2, widthPct: 100, align: 'center' },
  },
];

export const heroWidget = defineWidget({
  type: 'hero',
  schema: {
    label: 'Hero Banner',
    description: 'Full-width image banner with overlay text and call-to-action',
    props: {},
    slots: {
      heading: { type: 'text', label: 'Heading', styleClasses: ['hero-heading'] },
      subheading: { type: 'text', label: 'Subheading' },
      backgroundImage: { type: 'image', label: 'Background Image' },
      ctaButton: { type: 'button', label: 'Call to Action' },
    },
    dataDeps: ['heroSlides'],
  },
  nameTh: 'แบนเนอร์หลัก',
  descriptionTh: 'แบนเนอร์ภาพเต็มความกว้างพร้อมข้อความและปุ่มดำเนินการ',
  category: 'content',
  thumbnail: '/widget-thumbnails/hero.svg',
  defaults: {
    type: 'hero',
    props: {},
    slots: {
      heading: { value: 'Welcome to our store', styleClass: 'hero-heading' },
      subheading: { value: 'Discover our latest collection' },
    },
  },
  defaultBlocks: heroDefaultBlocks,
});
